import FJActionConstant from '../../constant/FJActionConstant'

let FJModalAction = (function () {
  return {
    /**
     * @description 显示modalConfirm模态框
     * @param data 详见 FJModalConfirm.reducer
     * @returns {{data: *, type: string}}
     */
    showConfirmModalAction: function (data) {
      return {
        type: FJActionConstant.SHOW_CONFIRM_MODAL,
        data,
      };
    },

    /**
     * @description 隐藏modalConfirm模态框
     * @returns {{type: *}}
     */
    hideConfirmModalAction: function () {
      return {
        type: FJActionConstant.HIDE_CONFIRM_MODAL
      };
    },

    /**
     * @description 初始化modalConfirm模态框
     * @returns {{type: *}}
     */
    initConfirmModalDataAction: function () {
      return {
        type: FJActionConstant.INIT_CONFIRM_MODAL_DATA
      };
    },

    /**
     * @description 设置全局loading的显示
     * @param data {boolean}
     * @returns {{data: *, type: string}}
     */
    setIsShowLoadingModalAction: function (data) {
      return {
        type: FJActionConstant.SET_IS_SHOW_LOADING_MODAL,
        data
      }
    },

    /**
     * @description 设置显示预览video的弹窗
     * @param data {boolean}
     * @returns {{data: *, type: string}}
     */
    setIsShowRecordingModalAction: function (data) {
      return {
        type: FJActionConstant.SET_IS_SHOW_RECORDING_MODAL,
        data
      };
    },

    /**
     * @description 设置录屏倒计时弹窗是否显示
     * @param data {boolean}
     * @returns {{data: *, type: string}}
     */
    setIsShowScreenRecordingModalAction: function (data) {
      return {
        type: FJActionConstant.SET_IS_SHOW_SCREEN_RECORDING_MODAL,
        data
      }
    },

    /**
     * @description 设置编辑文字弹窗是否显示
     * @param data {boolean}
     * @returns {{data: *, type: string}}
     */
    setIsShowTextEditorModalAction: function (data) {
      return {
        type: FJActionConstant.SET_IS_SHOW_TEXT_EDITOR_MODAL,
        data
      }
    },

    /**
     * @description 设置relink弹窗是否显示
     * @param data {boolean}
     * @returns {{data: *, type: string}}
     */
    setIsShowRelinkModalAction: function (data) {
      return {
        type: FJActionConstant.SET_IS_SHOW_RELINK_MODAL,
        data
      }
    },
    /**
     * @desc 设置是否显示不支持safari的弹窗
     * @param isShow - 是否显示
     * @return {{isShow: boolean, type: string}}
     */
    setIsShowUnsupportSafariModalAction: function (isShow) {
      return {
        type: FJActionConstant.SET_IS_SHOW_UNSUPPORT_SAFARI_MODAL,
        isShow: isShow
      }
    },

    /**
     * @description 设置record-from弹窗是否显示
     * @param data {boolean}
     * @returns {{data: *, type: string}}
     */
    setIsShowReRecordFromModalAction: function (data) {
      return {
        type: FJActionConstant.SET_IS_SHOW_RECORD_FROM_MODAL,
        data
      }
    },

    /**
     * @description
     * @param data
     * @returns {{data: *, type: string}}
     */
    setIsShowQuickGuideModalAction: function (data) {
      return {
        type: FJActionConstant.SET_IS_SHOW_QUICK_GUIDE_MODAL,
        data
      }
    },

		/**
		 * @description 设置 stockvideo 弹窗
		 * @param data
		 */
		setIsShowStockVideoModelAction: function (data) {
			return {
				type: FJActionConstant.SET_IS_SHOW_STOCK_VIDEO_MODAL,
				data
			}
		},

    /**
     * @description 设置dropbox分享是否显示
     * @param data
     * @return {{data, type: string}}
     */
		setIsShowDropboxModalAction: function (data) {
      return {
        type: FJActionConstant.SET_IS_SHOW_DROPBOX_MODAL,
        data
      }
    },

    /**
     * @description 设置dropbox分享成功是否显示
     * @param isShow
     * @param shareUrl
     * @return {{data, shareUrl, type: string}}
     */
    setIsShowDropboxSuccessModalAction: function (isShow, shareUrl) {
		  return {
		    type: FJActionConstant.SET_IS_SHOW_DROPBOX_SUCCESS_MODAL,
        data: isShow,
        shareUrl,
      }
    },

    /**
     * @description 设置显示云空间升级的弹窗
     * @param data {boolean}
     * @returns {{data: *, type: string}}
     */
    setIsShowCloudBenefitModalAction: function (data) {
      return {
        type: FJActionConstant.SET_IS_SHOW_CLOUD_BENEFIT_MODAL,
        data
      };
    },
  }
})();

export default FJModalAction;
